module.exports = __webpack_public_path__ + "media/Rudy_rooster_crowing-Shelley-1948282641.6a540953.mp3";